import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type CheckInRemarkMutationPayload = {
  checkin_remark_id: number;
  handled: boolean;
};

export const useCheckInRemarkMutation = () =>
  useTypedMutation<CheckInRemarkMutationPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/check_in/remark/handle", payload);
    },
    onSuccess: ({ checkin_remark_id, handled }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.customer_communication?.check_in_remarks?.length) return;

      const checkInRemarkIdx = appointment.customer_communication.check_in_remarks.findIndex(remark => remark.id === checkin_remark_id);
      if (checkInRemarkIdx < 0) return;

      const customer_communication = {
        ...appointment.customer_communication,
        check_in_remarks: appointment.customer_communication.check_in_remarks.with(checkInRemarkIdx, {
          ...appointment.customer_communication.check_in_remarks[checkInRemarkIdx],
          receptionist_handled: handled
        })
      };

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, customer_communication });
    }
  });
